module.exports = __webpack_public_path__ + "static/media/currency_exchange.71f51efe.jpg";